import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as service from '@/services/tagsService';
import { useAuth } from '@/hooks/useAuth';
import type { Tag } from '@/types/models';

const KEY = 'tags';

export function useAllTags() {
  const { churchId } = useAuth();

  return useQuery({
    queryKey: [KEY, 'church', churchId],
    queryFn: () => service.getTagsByChurch(churchId!),
    enabled: !!churchId,
  });
}

export function useTaskTags(taskId: string | undefined) {
  return useQuery({
    queryKey: [KEY, 'task', taskId],
    queryFn: () => service.getTagsByTask(taskId!),
    enabled: !!taskId,
  });
}

export function useReasonTags(reasonId: string | undefined) {
  return useQuery({
    queryKey: [KEY, 'reason', reasonId],
    queryFn: () => service.getTagsByReason(reasonId!),
    enabled: !!reasonId,
  });
}

export function useAddTag() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Omit<Tag, 'id'>) => service.addTag(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
}

export function useRemoveTag() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => service.removeTag(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
}
